(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
      class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.getElementById('shopify-section-headers') || this;
          this.headerBounds = {};
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

          if (scrollTop > this.headerBounds.bottom) {
            // Keep the navigation visible after passing the original header.
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
          this.header.classList.add('shopify-section-header-hidden');
          this.header.classList.remove('shopify-section-header-sticky');
          this.closeMenuDisclosure();
        }

        reveal() {
          this.header.classList.add('shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
          this.disclosures.forEach(disclosure => disclosure.close());
        }

        // closeSearchModal() {
        //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        //   this.searchModal.close(false);
        // }
      }

      customElements.define('sticky-header', StickyHeader);
      
      if (!customElements.get('header-drawer')) {
        class HeaderDrawer extends HTMLElement {
          constructor() {
            super();
            this.mainDetailsToggle = this.querySelector('details');
            this.addEventListener('keyup', this.onKeyUp.bind(this));
            this.addEventListener('focusout', this.onFocusOut.bind(this));
            this.bindEvents();
          }

          bindEvents() {
            this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
            this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
          }

          onKeyUp(event) {
            if(event.code.toUpperCase() !== 'ESCAPE') return;
            const openDetails = event.target.closest('details[open]');
            if(!openDetails) return;
            openDetails === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetails);
          }

          onSummaryClick(event) {
            const summaryElement = event.currentTarget;
            const detailsElement = summaryElement.parentNode;
            const isOpen = detailsElement.hasAttribute('open');
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

            function addTrapFocus() {
              const elementToFocus = detailsElement.querySelector('button') || detailsElement.querySelector('a');
              if (elementToFocus) elementToFocus.focus();
            }

            if (detailsElement === this.mainDetailsToggle) {
              if (isOpen) {
                event.preventDefault();
                this.closeMenuDrawer(event, summaryElement);
              } else {
                this.openMenuDrawer(summaryElement);
              }
            } else {
                setTimeout(() => {
                    detailsElement.classList.add('menu-opening');
                    summaryElement.setAttribute('aria-expanded', true);
                    addTrapFocus();
                }, 100);
            }
          }

          openMenuDrawer(summaryElement) {
            setTimeout(() => {
              this.mainDetailsToggle.classList.add('menu-opening');
            });
            summaryElement.setAttribute('aria-expanded', true);
            document.body.classList.add('overflow-hidden-mobile');
          }

          closeMenuDrawer(event, elementToFocus = false) {
              if (event !== undefined) {
                this.mainDetailsToggle.classList.remove('menu-opening');
                document.body.classList.remove('overflow-hidden-mobile');
                setTimeout(() => {
                    this.mainDetailsToggle.removeAttribute('open');
                    this.mainDetailsToggle.querySelectorAll('summary').forEach(summary => {
                      summary.setAttribute('aria-expanded', false);
                    });
                }, 300);
              }
          }
          
          onCloseButtonClick(event) {
              const detailsElement = event.currentTarget.closest('details');
              this.closeMenuDrawer(event, detailsElement.querySelector('summary'));
          }

          onFocusOut(event) {
            setTimeout(() => {
              if (this.mainDetailsToggle.hasAttribute('open') && !this.contains(document.activeElement)) this.closeMenuDrawer();
            });
          }
        }
        customElements.define('header-drawer', HeaderDrawer);
      }
            
            
      class LocalizationForm extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('.disclosure__list-wrapper'),
          };
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
          this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
        }

        hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
        }

        onContainerKeyUp(event) {
          if (event.code.toUpperCase() !== 'ESCAPE') return;

          this.hidePanel();
          this.elements.button.focus();
        }

        onItemClick(event) {
          event.preventDefault();
          const form = this.querySelector('form');
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }

        openSelector() {
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }

        closeSelector(event) {
          const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
          if (event.relatedTarget === null || shouldClose) {
            this.hidePanel();
          }
        }
      }

      customElements.define('localization-form', LocalizationForm);



      
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlet-contact-map"] && !Shopify.designMode) return;
  try {
    
  function toggleDetailsCheckbox() {
    const cb = document.getElementById('OutletContactForm-save');
    if (cb) {
      // Toggle value when container is clicked (optional helper)
    }
  }

  // Simple script to remember name and email in localStorage if checkbox is ticked
  document.addEventListener("DOMContentLoaded", function() {
    const nameInput = document.getElementById("OutletContactForm-name");
    const emailInput = document.getElementById("OutletContactForm-email");
    const saveCb = document.getElementById("OutletContactForm-save");
    const form = document.getElementById("OutletContactForm");

    if (nameInput && emailInput && saveCb) {
      // Load saved values
      if (localStorage.getItem("outlet_form_save") === "true") {
        nameInput.value = localStorage.getItem("outlet_form_name") || "";
        emailInput.value = localStorage.getItem("outlet_form_email") || "";
        saveCb.checked = true;
      }

      // Save values on submit if checked
      if (form) {
        form.addEventListener("submit", function() {
          if (saveCb.checked) {
            localStorage.setItem("outlet_form_name", nameInput.value);
            localStorage.setItem("outlet_form_email", emailInput.value);
            localStorage.setItem("outlet_form_save", "true");
          } else {
            localStorage.removeItem("outlet_form_name");
            localStorage.removeItem("outlet_form_email");
            localStorage.setItem("outlet_form_save", "false");
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const galleryItems = document.querySelectorAll(".gallery-item");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const lightboxClose = document.getElementById("lightbox-close");
  const nextBtn = document.getElementById("lightbox-next");
  const prevBtn = document.getElementById("lightbox-prev");

  let imageList = [];
  let currentIndex = 0;

  // Collect all images
  function updateImageList() {
    imageList = Array.from(document.querySelectorAll(".gallery-item img")).filter(img => img.closest(".gallery-item").style.display !== "none");
  }

  // Open Lightbox
  function openLightbox(index) {
    const img = imageList[index];
    if (img) {
      lightboxImg.src = img.getAttribute("data-full");
      lightbox.style.display = "flex";
      currentIndex = index;
    }
  }

  // Event: image click
  document.querySelectorAll(".gallery-item img").forEach((img, index) => {
    img.addEventListener("click", () => {
      updateImageList();
      const visibleImages = imageList;
      const clickedImg = img;
      const newIndex = visibleImages.indexOf(clickedImg);
      openLightbox(newIndex);
    });
  });

  // Next/Prev buttons
  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % imageList.length;
    openLightbox(currentIndex);
  });
  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + imageList.length) % imageList.length;
    openLightbox(currentIndex);
  });

  // Close lightbox
  lightboxClose.addEventListener("click", () => {
    lightbox.style.display = "none";
    lightboxImg.src = "";
  });

  // Close on outside click
  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = "none";
      lightboxImg.src = "";
    }
  });

  // Keyboard support
  document.addEventListener("keydown", (e) => {
    if (lightbox.style.display === "flex") {
      if (e.key === "ArrowRight") nextBtn.click();
      if (e.key === "ArrowLeft") prevBtn.click();
      if (e.key === "Escape") lightboxClose.click();
    }
  });

  // Filter buttons
  filterButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      filterButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      const filter = btn.dataset.filter;
      galleryItems.forEach(item => {
        const category = item.dataset.category;
        item.style.display = (filter === 'all' || filter === category) ? 'block' : 'none';
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyine-number-counter"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $(".video__btn-play").on("click", function (e) {
    e.preventDefault();
    $('body').addClass('overlay-active');
    $(".video-popup,.video-container,.video-wrapper,.pop-up__video-close ").show();
    var srchref = "",
        autoplay = "",
        id = $(this).data("id");
    if ($(this).data("type") == "vimeo")
      var srchref = "//player.vimeo.com/video/";
    else if ($(this).data("type") == "youtube")
      var srchref = "https://www.youtube.com/embed/";
    if ($(this).data("autoplay") == true) autoplay = "?autoplay=1";
    $("#video-popup-iframe").attr("src", srchref + id + autoplay);
    $("#video-popup-iframe").on("load", function () {
      $(".video-wrapper").show();
    });
  });

  $(".pop-up__video-close , .video-popup").on("click", function (e) {
     $('body').removeClass('overlay-active');
    $(".video-container,.video-wrapper,.pop-up__video-close ,.video-popup").hide();
    $("#video-popup-iframe").attr("src", "");
  });
});


  } catch(e) { console.error(e); }
})();
})();
